export default __webpack_public_path__ + "static/media/heart.ba24e58f.svg";